// schema.js
export const eventsSchema = () => ({
  title: 'Events',
  fieldsets: [
    {
      id: 'default',
      title: 'Events settings',
      fields: [
        'blockTitle',
        'mode',
        'limit',
        'slidesToShow',
        'autoplay',
        'autoplayDelay',
        'loop',
        'hideArrows',
        'hideDots',
        'accordionByYear',
        'navPath',      // path text field
        'tagFilter',    // tag filter (Subject)
        'showImage',
        'showDate',
        'showLocation',
        'showTags',
        'showContactPerson',
        'showDescription',
        'buttonText',
      ],
    },
  ],
  properties: {
    blockTitle: { title: 'Block title', type: 'string' },
    mode: {
      title: 'Display as',
      type: 'string',
      factory: 'Choice',
      choices: [
        ['list', 'List'],
        ['carousel', 'Carousel'],
        ['agenda', 'Agenda (upcoming only)'],
        ['all', 'All events (like Agenda)'],
      ],
      default: 'agenda',
    },
    limit: { title: 'Batch size', type: 'number', default: 8 },
    slidesToShow: { title: 'Max slides visible (carousel)', type: 'number', default: 1 },
    autoplay: { title: 'Autoplay (carousel)', type: 'boolean', default: false },
    autoplayDelay: { title: 'Autoplay delay (ms)', type: 'number', default: 6000 },
    loop: { title: 'Loop infinitely (carousel)', type: 'boolean', default: true },
    hideArrows: { title: 'Hide arrows (carousel)', type: 'boolean' },
    hideDots: { title: 'Hide dots (carousel)', type: 'boolean' },
    accordionByYear: { title: 'Split into accordion by year (All events)', type: 'boolean', default: false },

    // Path field (text only)
    navPath: {
      title: 'Path (optional)',
      type: 'string',
      description: 'Example: /disciplines/open-water/events',
    },

    // Tag filter (Subject)
    tagFilter: {
      title: 'Tag(s) (optional)',
      type: 'string',
      description: 'One tag or comma-separated (e.g. "gala, provincial").',
    },

    showImage: { title: 'Show image', type: 'boolean', default: true },
    showDate: { title: 'Show date/time line', type: 'boolean', default: true },
    showLocation: { title: 'Show location', type: 'boolean', default: true },
    showTags: { title: 'Show tags', type: 'boolean', default: true },
    showContactPerson: { title: 'Show contact person', type: 'boolean', default: true },
    showDescription: { title: 'Show description', type: 'boolean', default: false },
    buttonText: { title: 'Button text', type: 'string', default: 'View event' },
  },
  required: [],
});
export default eventsSchema;
